import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ragService from "../../services/ragService";
import { cardStyle, greyBorderStyle } from "../../shared/Theme";
import HexBar from "./HexBar";

const CardCyberRiskExposure = () => {

	const navigate = useNavigate();
	
	let [ percentages, setPercentages ] = useState(null);
		
	useEffect(() => {
		let riskCounts = ragService.ragCounts();
		let total = riskCounts.red + riskCounts.amber + riskCounts.green;
		setPercentages({
			red: (total > 0)? (riskCounts.red / total) * 100 : 0,
			amber: (total > 0)? (riskCounts.amber / total) * 100 : 0,
			green: (total > 0)? (riskCounts.green / total) * 100 : 0
		});
	}, []);
	
	const handleTitleClick = () => {
		navigate("/risk");
	};
	
	return (
		<Box sx={{ borderRight: "2px solid", ...greyBorderStyle }}>
			<Stack
				direction="column"
				onClick={handleTitleClick}
				sx={{
					...cardStyle,
					width: "28em",
					height: "16em",
					cursor: "pointer"
				}}
			>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						marginBottom: "0.65em",
						fontWeight: "bold"
					}}
				>
					Cyber Risk Exposure
				</Typography>
				<Box sx={{ marginTop: "2em" }}>
					<HexBar percentages={percentages} sx={{ marginTop: "2em" }} />
				</Box>
			</Stack>
		</Box>
	);

}

export default CardCyberRiskExposure;